import { motion } from "framer-motion";
import { Shield, Clock, Star } from "lucide-react";
import { Seo, breadcrumbSchema } from "../components/Seo";
import { JotformEmbed } from "../components/JotformEmbed";

const PATH = "/get-a-quote";

const TRUST = [
  { icon: Clock, label: "Quote in hours" },
  { icon: Shield, label: "Fixed price, no extras" },
  { icon: Star, label: "7-day re-clean guarantee" },
];

const GetAQuote = () => (
  <>
    <Seo
      title="Get a Free Quote — End of Tenancy Cleaning London | Prime Tenancy Cleaning"
      description="Request a fixed-price end of tenancy cleaning quote in London. Fill in the form and we'll get back to you within hours. All 32 boroughs covered."
      ogTitle="Get a Free End of Tenancy Cleaning Quote — London"
      ogDescription="Fixed price, same-day response, 7-day re-clean guarantee. All 32 London boroughs covered by Prime Tenancy Cleaning."
      path={PATH}
      schema={[breadcrumbSchema([{ name: "Get a Quote", path: PATH }])]}
    />

    {/* Compact page top — sits just below the fixed nav */}
    <div className="bg-navy pt-24 pb-8 px-6 text-center">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="inline-block text-teal font-semibold text-sm uppercase tracking-wider mb-3">
          Free Quote
        </span>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-2">
          Request Your Cleaning Quote
        </h1>
        <p className="text-slate-300 text-base max-w-lg mx-auto">
          Tell us your postcode, property size and date — we'll send a fixed price within hours.
        </p>
      </motion.div>

      {/* Trust pills */}
      <div className="flex flex-wrap justify-center gap-3 mt-5">
        {TRUST.map(({ icon: Icon, label }) => (
          <div
            key={label}
            className="flex items-center gap-1.5 bg-white/10 text-slate-200 text-xs font-medium px-3 py-1.5 rounded-full"
          >
            <Icon className="w-3.5 h-3.5 text-teal flex-shrink-0" />
            {label}
          </div>
        ))}
      </div>
    </div>

    {/* Form — immediately visible, no scroll required */}
    <div className="bg-slate-50 px-4 py-8 md:py-12 min-h-screen">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-8"
      >
        <JotformEmbed testId="quote-page-jotform" />
        <p className="text-xs text-slate-400 mt-4 text-center">
          Prefer to talk? Call{" "}
          <a href="tel:+442080363586" className="text-teal font-semibold">
            020 8036 3586
          </a>{" "}
          or{" "}
          <a
            href="https://wa.me/447346006547"
            target="_blank"
            rel="noopener noreferrer"
            className="text-teal font-semibold"
          >
            WhatsApp us
          </a>
          .
        </p>
      </motion.div>
    </div>
  </>
);

export default GetAQuote;
